
import { Vue,Component,Prop,Ref, Watch } from "vue-property-decorator";

import * as echarts from "echarts";

@Component({ name: 'home-components-brandDetection' })
export default class BrandDetection extends Vue {
  @Prop() readonly list: Array<any>;
  @Prop() readonly color: string;
  @Ref("chart") chartRef: HTMLElement;

  chart = null;
  get chartOptions() {
    return {
      tooltip: {
        trigger: "item", // 鼠标悬停在数据项上触发 tooltip
        formatter: "{b}：{c}次",
      },
      legend: {
        show: false,
      },
      grid: {
        top: 20,
        left: "3%",
        right: "15%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        type: "category",
        data: this.list?.map((el) => el.name)?.reverse(),
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      series: [
        {
          type: "bar",
          data: this.list?.map((el) => el.value)?.reverse(),
          barWidth: 25,
          color: this.color || "#95DE64",
          label: {
            show: true,
            position: "right",
          },
        },
      ],
    };
  }

  @Watch("list", { deep: true, immediate: true })
  drawChart() {
    this.$nextTick(() => {
      if (!this.chartRef || !this.list?.length) return;
      this.chart = echarts.init(this.chartRef);
      this.chart.setOption(this.chartOptions)
    })
  }




}
